import React from 'react';
import { 
  SkeletonHero, 
  SkeletonContactCard, 
  SkeletonForm, 
  SkeletonInfoCard,
  SkeletonFaqItem,
  SkeletonTitle,
  SkeletonText,
  SkeletonButton,
  Skeleton
} from '../ui/skeletons';

// Contact Page Full Skeleton
const ContactPageSkeleton = () => (
  <div className="bg-[#FAF6F1] min-h-screen">
    {/* Header Skeleton */}
    <div className="fixed top-0 left-0 right-0 z-50 px-3 py-3">
      <div className="bg-white/80 backdrop-blur-md rounded-2xl px-6 py-4 flex items-center justify-between">
        <Skeleton className="w-32 h-8 rounded-lg" />
        <div className="hidden lg:flex items-center gap-8">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="w-20 h-4 rounded" />
          ))}
        </div>
        <SkeletonButton size="md" />
      </div>
    </div>

    <main className="pt-24">
      {/* Hero Section Skeleton */}
      <section className="relative min-h-[70vh] overflow-hidden p-3">
        <SkeletonHero />
      </section>

      {/* Contact Methods Section Skeleton */}
      <section className="py-4 px-3">
        <div className="window-content bg-gradient-to-br from-[#D4E0D0] via-[#E0EAD8] to-[#D4E0D0] rounded-3xl py-16 px-6 lg:px-8">
          <div className="max-w-[1200px] mx-auto">
            {/* Title */}
            <div className="text-center mb-12">
              <SkeletonText width="120px" className="h-3 mx-auto mb-3" />
              <SkeletonTitle size="xl" className="mx-auto w-80" />
            </div>
            
            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {Array.from({ length: 3 }).map((_, i) => (
                <SkeletonContactCard key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Form Section Skeleton */}
      <section className="py-4 px-3">
        <div className="window-content bg-gradient-to-br from-[#F5E6D3] via-[#FAF0E6] to-[#F5E6D3] rounded-3xl py-16 px-6 lg:px-8">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
              {/* Info Cards */}
              <div className="space-y-6">
                <div className="mb-8">
                  <SkeletonText width="100px" className="h-3 mb-3" />
                  <SkeletonTitle size="lg" className="w-64" />
                </div>
                {Array.from({ length: 3 }).map((_, i) => (
                  <SkeletonInfoCard key={i} />
                ))}
                {/* Quote skeleton */}
                <div className="bg-[#1E1E1E] rounded-2xl p-6 space-y-4">
                  <Skeleton className="h-20 bg-white/10 rounded" />
                  <SkeletonText width="80px" className="bg-white/10" />
                </div>
              </div>
              
              {/* Form */}
              <SkeletonForm />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section Skeleton */}
      <section className="py-4 px-3">
        <div className="window-content bg-white rounded-3xl py-16 px-6 lg:px-8">
          <div className="max-w-[900px] mx-auto">
            {/* Title */}
            <div className="text-center mb-12">
              <SkeletonText width="60px" className="h-3 mx-auto mb-3" />
              <SkeletonTitle size="xl" className="mx-auto w-72" />
            </div>
            
            {/* FAQ Items */}
            <div className="space-y-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <SkeletonFaqItem key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section Skeleton */}
      <section className="py-4 px-3 pb-6">
        <div className="window-content bg-gradient-to-br from-[#FFDAB3] via-[#FFE4C9] to-[#FFDAB3] rounded-3xl py-16 px-8">
          <div className="max-w-[900px] mx-auto text-center">
            <SkeletonTitle size="xl" className="mx-auto w-80 mb-6" />
            <Skeleton className="h-6 w-96 mx-auto rounded mb-10" />
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <SkeletonButton size="xl" className="w-52" />
              <SkeletonButton size="xl" className="w-40" />
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
);

export { ContactPageSkeleton };
